<template>
  <div class="steps-component">
    <div class="line-through"></div>
    <ul>
      <li
        v-for="(item, index) in items"
        :key="item.key"
        :class="{'current-step': current >= index + 1}"
      >
        <span class="index">{{ index + 1 }}</span>
        <span class="name">{{ item.name }}</span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'c-steps',
  props: {
    items: {
      type: Array,
      default: function() {
        return [
          {
            key: 'stepOne',
            name: '手机注册'
          },
          {
            key: 'stepTwo',
            name: '选择服务'
          },
          {
            key: 'stepThree',
            name: '资质认证'
          },
          {
            key: 'stepFour',
            name: '开始使用'
          }
        ]
      }
    },
    current: Number || String
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss">
@import './style.scss';
</style>
